import { render, staticRenderFns } from "./InviteSysAdminMemberForm.vue?vue&type=template&id=70cea263&"
import script from "./InviteSysAdminMemberForm.vue?vue&type=script&lang=js&"
export * from "./InviteSysAdminMemberForm.vue?vue&type=script&lang=js&"
import style0 from "./InviteSysAdminMemberForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports